import { SVGProps } from 'react';
const SvgMinusRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <circle opacity={0.3} cx={12.5} cy={12} r={10} fill="#7D7D7D" />
    <rect x={6.5} y={11} width={12} height={2} rx={1} fill="#7D7D7D" />
  </svg>
);
export default SvgMinusRounded;
